import {
  CompanyFactKey,
  CompanyFactSchemaVersion,
  ConflictStrategy,
  type FactKeyConfig,
} from '../core'

export enum BackgroundCheckOption {
  CLEAN = 'CLEAN',
  SPECIFIC = 'SPECIFIC',
  TRABA = 'TRABA',
  SECOND_CHANCE = 'SECOND_CHANCE',
}

export const ONBOARDING_KEY_CONFIG: Partial<
  Record<CompanyFactKey, FactKeyConfig>
> = {
  [CompanyFactKey.ONBOARDING_BACKGROUND_CHECK]: {
    schemaVersion: CompanyFactSchemaVersion.SINGLE_SELECT_WITH_NOTES_V1,
    displayName: 'Background Check',
    options: Object.values(BackgroundCheckOption),
  },
  [CompanyFactKey.ONBOARDING_DRUG_TEST]: {
    schemaVersion: CompanyFactSchemaVersion.DRUG_TEST_V2,
    displayName: 'Drug Test',
  },
  [CompanyFactKey.ONBOARDING_RESUME_REVIEW]: {
    schemaVersion: CompanyFactSchemaVersion.YES_NO_WITH_NOTES_V1,
    displayName: 'Resume Review',
  },
  [CompanyFactKey.ONBOARDING_INTERVIEW]: {
    schemaVersion: CompanyFactSchemaVersion.YES_NO_WITH_NOTES_V1,
    displayName: 'Interview',
  },
  [CompanyFactKey.ONBOARDING_ONLINE_ORIENTATION]: {
    schemaVersion: CompanyFactSchemaVersion.YES_NO_WITH_NOTES_V1,
    displayName: 'Online Orientation',
  },
  [CompanyFactKey.ONBOARDING_SITE_ORIENTATION]: {
    schemaVersion: CompanyFactSchemaVersion.YES_NO_WITH_NOTES_V1,
    displayName: 'Site Orientation',
  },
  [CompanyFactKey.ONBOARDING_TOUR]: {
    schemaVersion: CompanyFactSchemaVersion.YES_NO_WITH_NOTES_V1,
    displayName: 'Tour',
  },
  [CompanyFactKey.ONBOARDING_NOTES]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Notes',
    conflictStrategy: ConflictStrategy.APPEND,
  },
  [CompanyFactKey.ONBOARDING_PROCESS_OVERVIEW]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Process Overview',
    conflictStrategy: ConflictStrategy.APPEND,
  },
  [CompanyFactKey.ONBOARDING_ADDITIONAL_REQUIREMENTS]: {
    schemaVersion: CompanyFactSchemaVersion.TEXT_V3,
    displayName: 'Additional Requirements',
    conflictStrategy: ConflictStrategy.APPEND,
  },
}
